const pageLinks = {
  ErrorExpired: {
    url: '/error/expired'
  },
  ErrorInvalid: {
    url: '/error/invalid'
  },
  ErrorUnavailable: {
    url: '/error/unavailable'
  },
  Home: {
    url: '/ebook'
  },
  PackagePlaylist: {
    url: '/packageplaylist'
  },
  Login: {
    url: '/login'
  }
};

export {
  pageLinks
};